module.exports = __webpack_public_path__ + "static/media/avc_video_icon_border.ff082811.svg";